import ExcelJS from "exceljs";
import { IExportarExcelPlantillaInfo } from "../../../../data/modulo/Admin";
import { UIUtilStrings } from "../../../util/Strings";
import { UIUtilTime } from "../../../util/Time";
import { IExcelExportConfig, IExcelExportSheetConfig } from "./Export";
import { ExcelThingsUtil as util } from "../Util";

const ABCCOLS = util.ABCCOLS
type IInfoImagenExcel = util.IInfoImagenExcel
type IConfigLogo = util.IConfigLogo

// NOTE IMPLEMENTAR
// export function _ExcelThingsExportWriteWorksheet(worksheet, ...args) {
// }

export namespace ExcelThingsExportWriteWorksheet {

    export function AjustaEncabezadosDeHoja<TDato>(
        hoja: ExcelJS.Worksheet,
        dataSheet: TDato[],
        templateInfo: IExportarExcelPlantillaInfo,
        config: IExcelExportConfig<TDato>
    ): Map<string, { celda: string, valor: keyof TDato }> {
        let mapCeldasEncabezados: Map<string, { celda: string, valor: keyof TDato }> = new Map();
        let origen = templateInfo.RangoTable[0].split("");

        //Inicizar Encabezado y array de Letras de los encabezados
        let nuevoOrigen = origen[0];
        let i = 0;

        config.ColumnsConfig.forEach((d) => {
            if (i == 0)
                mapCeldasEncabezados.set(templateInfo.RangoTable[0], { celda: templateInfo.RangoTable[0], valor: d.Field });
            else {
                let getIndex = ABCCOLS.indexOf(nuevoOrigen);
                let cell = ABCCOLS[getIndex + 1] + origen[1];
                nuevoOrigen = ABCCOLS[getIndex + 1];
                mapCeldasEncabezados.set(cell, { celda: cell, valor: d.Field });
            }
            i++;
        });

        //insertar Fecha de descarga
        hoja.getCell(templateInfo.FechaDescrga).value = UIUtilTime._DateFormatStandar(new Date()) // .toDateString();
        hoja.getCell(templateInfo.Escuela).value = config.OnGetEscuelasTagInSheet(dataSheet); //  nombreEscuela; // config.Escuela.titulo;
        hoja.getCell(templateInfo.Titulo).value = config.TagEncabezadoHoja;

        /**
         * Estilos a las columnas
         */
        let acum = parseInt(origen[1]);
        let styleColuma = hoja.getCell(templateInfo.RangoTable[0]).style;

        mapCeldasEncabezados.forEach(function (datoCelda, i) {
            hoja.getCell(datoCelda.celda).style = styleColuma;
            hoja.getColumn(acum).width = 15;
            acum = acum + 1;
        });

        return mapCeldasEncabezados
    }


    export async function InsertarDatosPorHoja<TDato>(
        book: ExcelJS.Workbook,
        item: IExcelExportSheetConfig<TDato>,
        infoLogoOriginal: IInfoImagenExcel,
        hojaOriginal: ExcelJS.Worksheet,
        templateInfo: IExportarExcelPlantillaInfo,
        config: IExcelExportConfig<TDato>,
        columnaTablaExcel: Array<ExcelJS.TableColumnProperties>,
        logoInfo?: IConfigLogo
    ) {
        // let item.IdSheet = item.IdSheet;
        let sheet: ExcelJS.Worksheet = book.getWorksheet(item.SheetName);
        let dataExcelFinal: any[][] = [];

        for (let datum of item.Data) {
            let row = [];
            for (let colConfig of config.ColumnsConfig) {
                let value: any = datum[colConfig.Field] || "";

                if (config.OnStepFieldInDataRow) {
                    let val = config.OnStepFieldInDataRow(colConfig.Field, datum);
                    if (val instanceof Promise) {
                        value = await val;
                    } else {
                        value = val;
                    }
                } else if (colConfig.TypeData == "date") {
                    if (typeof value == "string" && value.trim()) {
                        // FIX_TIMEZONE
                        // value = new Date(value); FIXME DESCOMENTAR AJUSTAR FORMATO DE SALIDA
                        value = UIUtilTime._DateFormatStandar(new Date(value)); // REMOVER
                    }
                    else if (!(value instanceof Date)) {
                        value = "";
                    }
                }
                else if (colConfig.TypeData == "number") {
                    if (typeof value == "string" && value.trim()) {
                        value = Number(value);
                    }
                    else if (!(typeof value == "number")) {
                        value = "";
                    }
                }
                row.push(value);
            }
            dataExcelFinal.push(row);
        }

        let origen = templateInfo.RangoTable[0].split("");
        // let configHoja = config.Hojas.get(item.IdSheet);
        let color = hojaOriginal.getCell(origen[0] + (parseInt(origen[1]) + 2)).style.fill;//B11
        const tableRowsAdded = item.Data.length >= 2 ? item.Data.length - 2 : 0;
        // const encabezadosInfo = Array.from(config.MapCampoEncabezado.values());

        //didujar filas con formato sin datos
        const mapCeldasEncabezados = AjustaEncabezadosDeHoja(sheet, item.Data, templateInfo, config);

        if (logoInfo?.Logo && logoInfo.IdExcelImagen > -1) {
            if (infoLogoOriginal) {
                sheet.addImage(logoInfo.IdExcelImagen, {// infoLogoOriginal.range)
                    tl: infoLogoOriginal.range.tl,
                    ext: { width: logoInfo.ExcelLogoWidth, height: logoInfo.ExcelLogoHeight }
                });
            } else {
                // console.info("Sin logo template")
                sheet.addImage(logoInfo.IdExcelImagen, {// infoLogoOriginal.range)
                    tl: { col: 1, row: 0 },
                    ext: { width: logoInfo.ExcelLogoWidth, height: logoInfo.ExcelLogoHeight }
                });
            }
        } else {
            if (infoLogoOriginal) {
                sheet.addImage(Number(infoLogoOriginal.imageId), infoLogoOriginal.range);
            }
        }

        /*Se quita el color de la celda default* */
        sheet.getCell(origen[0] + (parseInt(origen[1]) + 2)).style.fill = sheet.getCell(origen[0] + (parseInt(origen[1]) + 1)).style.fill;
        //B11                                                                    B10

        sheet.removeTable("MyTable");
        let insertedRows = sheet.insertRows(parseInt(origen[1]) + 2, new Array(tableRowsAdded), "i");

        sheet.addTable({
            name: 'MyTable',
            ref: templateInfo.RangoTable[0],//7
            headerRow: true,
            totalsRow: false,
            columns: columnaTablaExcel,//columnas,
            rows: dataExcelFinal
        });

        let ArrayEncabezado = Array.from(mapCeldasEncabezados.values());
        let FinalDiagonal = ArrayEncabezado[ArrayEncabezado.length - 1].celda.split("");
        let RangoInicio = origen[0] + (parseInt(origen[1]) + 1);

        let numeroFinal = (FinalDiagonal.length === 3) ? parseInt(FinalDiagonal[1] + FinalDiagonal[2]) : parseInt(FinalDiagonal[1]);
        let RangoFinal = FinalDiagonal[0] + (numeroFinal + item.Data.length);

        sheet.addConditionalFormatting({
            ref: RangoInicio + ":" + RangoFinal,
            rules: [
                {
                    type: "expression",
                    priority: 1,
                    formulae: ['MOD(ROW(),2)'],
                    style: {
                        fill: { type: 'pattern', pattern: 'solid', bgColor: { argb: color["fgColor"]["argb"] } } as any
                    }
                }
            ]
        });

        /**
         * Ajustar el pie de pagina
         */
        const [pieCol, pieRowP1, pieRowP2] = templateInfo.Pie.split("");
        const indiceLetraF = FinalDiagonal[0];
        const pieRowConfig = (pieRowP2 != null) ? parseInt(pieRowP1 + pieRowP2) : parseInt(pieRowP1);
        const pieRowFinal = pieRowConfig + tableRowsAdded;
        const cellnameTotal = indiceLetraF + pieRowFinal;

        const pieIndexCol2 = util.ABCCOLS.indexOf(pieCol) + 1;
        const cellnamePieTotalTemp = util.ABCCOLS[pieIndexCol2] + pieRowFinal
        // let indiceLetra = util.abecedario.indexOf(pieCol);
        const cellnamePieMergeCellInicio = pieCol + pieRowFinal;
        const cellnamePieMergeCellFinal = util.ABCCOLS[pieIndexCol2] + pieRowFinal;

        const cellPieStyleLabelTemplate = sheet.getCell(cellnamePieMergeCellInicio).style;
        const cellPieStyleValueTemplate = sheet.getCell(cellnamePieTotalTemp).style;

        /*Imprimir el total de las filas* */
        sheet.getCell(cellnameTotal).value = item.Data.length;
        sheet.getCell(cellnameTotal).style = cellPieStyleValueTemplate;

        /*Merge de las filas* */
        const totalLabeltoFix: string = sheet.getCell(cellnamePieMergeCellInicio).value + "";
        sheet.getCell(cellnamePieMergeCellInicio).value = UIUtilStrings._CapitaliceString(totalLabeltoFix.toLowerCase());
        sheet.mergeCells(`${cellnamePieMergeCellInicio}:${cellnamePieMergeCellFinal}`);

        let extraRowPie = pieRowFinal
        item.ExtraPie?.forEach(({ Label, Value, Alignment }) => {
            extraRowPie++;
            const cellnamePieExtraMergeCellInicio = pieCol + extraRowPie;
            const cellnamePieExtraMergeCellFinal = util.ABCCOLS[pieIndexCol2] + extraRowPie;
            const cellnamePieExtraValue = indiceLetraF + extraRowPie;

            sheet.getCell(cellnamePieExtraMergeCellInicio).value = Label;
            sheet.getCell(cellnamePieExtraMergeCellInicio).style = cellPieStyleLabelTemplate;
            sheet.mergeCells(`${cellnamePieExtraMergeCellInicio}:${cellnamePieExtraMergeCellFinal}`);

            sheet.getCell(cellnamePieExtraValue).value = Value;
            sheet.getCell(cellnamePieExtraValue).style = cellPieStyleValueTemplate;
            sheet.getCell(cellnamePieExtraValue).alignment = { horizontal: Alignment || "left" }
        })

        let noLastRowTable = parseInt(origen[1]) + 1;
        let indexCol = 0;
        if (insertedRows) {
            insertedRows.forEach(row => {
                noLastRowTable = row.number + 1;
                row.eachCell((cell, noCol) => {
                    if (config.ColumnsConfig[indexCol] && config.ColumnsConfig[indexCol].WidthCell) {
                        sheet.getColumn(noCol).width = config.ColumnsConfig[indexCol].WidthCell;
                    }
                    cell.alignment = {
                        wrapText: true
                    }
                    indexCol++;
                });
                indexCol = 0;
            });
        }
        sheet.getRow(noLastRowTable).eachCell((cell, noCol) => {
            if (config.ColumnsConfig[indexCol] && config.ColumnsConfig[indexCol].WidthCell) {
                sheet.getColumn(noCol).width = config.ColumnsConfig[indexCol].WidthCell;
            }
            cell.alignment = { wrapText: true }
            indexCol++;
        });
    }

}